import { Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GeneralService } from './general.service';
import { HttpClient } from '@angular/common/http';
import {
  ApiResponseLocationSite,
  PaginatedResponse,
  LocationSite,
  LocationDetailResponse,
  EditClosingField,
  ApiResponseLocationSiteData,
  WorkFlowType,
} from '../models/location-model/location.model';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public getLocation(params: {
    Page: number;
    PageSize: number;
    SearchField?: string | null;
    SearchFieldValue?: string | null;
    Sort?: string;
    SortDir?: string;
    'DefaultSearchFields[0].Text'?: string;
    'DefaultSearchFields[0].Value'?: string;
  }): Observable<ApiResponseLocationSite<PaginatedResponse<LocationSite>> | null> {
    const paramsAux = this.generalService.buildParamsEncoder(params);
    return this.http
      .get<
        ApiResponseLocationSite<PaginatedResponse<LocationSite>>
      >(this.URL_API + `/api/Location/Paged`, { params: paramsAux })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getLocationDetail(
    id: number,
  ): Observable<ApiResponseLocationSite<LocationDetailResponse> | null> {
    return this.http
      .get<
        ApiResponseLocationSite<LocationDetailResponse>
      >(this.URL_API + `/api/Location/Detail/${id}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getLocationDetailByKey(
    key: string,
  ): Observable<ApiResponseLocationSite<LocationDetailResponse> | null> {
    return this.http
      .get<
        ApiResponseLocationSite<LocationDetailResponse>
      >(this.URL_API + `/api/Location/Detail/Key?key=${key}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public LocationEditClosingField(
    id: number,
  ): Observable<ApiResponseLocationSiteData<EditClosingField> | null> {
    return this.http
      .get<
        ApiResponseLocationSiteData<EditClosingField>
      >(this.URL_API + `/api/LocationEditClosingField/List/Current/${id}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getWorkFlowType(
    CustomerId: number,
  ): Observable<ApiResponseLocationSiteData<WorkFlowType> | null> {
    const params = this.generalService.buildParamsEncoder({ CustomerId });
    return this.http
      .get<
        ApiResponseLocationSiteData<WorkFlowType>
      >(this.URL_API + `/api/WorkFlowType/List`, { params })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
